export default "__VITE_ASSET__DFHKmliU__"